import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqItems } from '../data/faq';
export function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqItems[0].id);
  return <section className="border-t border-white/10 bg-navy-800" data-id="element-58" data-mp="1lctvwo09f1hg">
      <div className="mx-auto w-full max-w-3xl px-4 py-14 sm:px-6 sm:py-20" data-id="element-59" data-mp="1gcpg7076easa">
        <h2 className="text-2xl font-extrabold tracking-tight text-white sm:text-3xl" data-id="element-60" data-mp="1gal1robnhtdr">
          Questions, Answered
        </h2>

        <ul className="mt-8 border-t border-white/10" data-id="element-61" data-mp="291mlm2qagd3m">
          {faqItems.map(item => {
          const isOpen = openId === item.id;
          return <li key={item.id} className="border-b border-white/10" data-id="element-62" data-mp="244cxqrijs9hw">
                <h3 data-id="element-63" data-mp="1z2ds1azc50hs">
                  <button type="button" aria-expanded={isOpen} aria-controls={`faq-panel-${item.id}`} onClick={() => setOpenId(isOpen ? null : item.id)} className="flex w-full items-center justify-between gap-4 py-4 text-left transition-colors duration-150 ease-out hover:text-brand-emerald focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-emerald" data-id="element-64" data-mp="1z2xen4zxkd25">
                    <span className="text-base font-semibold text-white sm:text-lg" data-id="element-65" data-mp="kiuvvygs5tle">
                      {item.question}
                    </span>
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center border border-white/20 text-brand-emerald" aria-hidden="true" data-id="element-66" data-mp="6qogwfpd5snj">
                      {isOpen ? <MinusIcon className="h-4 w-4" strokeWidth={2.5} data-id="element-67" data-mp="1sd7g62zdk5u" /> : <PlusIcon className="h-4 w-4" strokeWidth={2.5} data-id="element-68" data-mp="3jy8av9dxi808" />}
                    </span>
                  </button>
                </h3>
                <div id={`faq-panel-${item.id}`} hidden={!isOpen} className="pb-5 pr-10 text-sm leading-relaxed text-slate-300 sm:text-base" data-id="element-69" data-mp="3o1o5k06ftyaa">
                  {item.answer}
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}